// @flow

export {default as createLabelsObject} from './createLabelsObject';
